module.exports = __webpack_public_path__ + "img/marker_entitats.20aa0390.svg";